module.exports = __webpack_public_path__ + "img/parallax-text-column-left.b468fb74.svg";